import { getQuery, postToServer, getFromServer, execQuery, luaScript } from '../../helpers/helper_store';

class Task {
	constructor(queueId, caption, pid, result, status) {
		this.pid = pid;
		this.caption = caption;
		this.queueId = queueId;
		this.result = result;
		this.status = status;
	}
}

const state = {
	rttasks: null,
	cmdLine: null,
	runningTaskData: null,
	finishedTaskData: null,
	deletedTaskData: null,
	rtLog: null,
	retFile: null,
	filesArray: [],
	statusTask: null,
	myTasks: []
};

const mutations = {
	setRTTasks: (state, data) => (state.rttasks = Array.isArray(data) ? data : [data]),
	setCmdLine: (state, data) => (state.cmdLine = Array.isArray(data) ? data : [data]),
	setRunningTaskData: (state, data) => (state.runningTaskData = Array.isArray(data) ? data : [data]),
	setFinishedTaskData: (state, data) => (state.finishedTaskData = Array.isArray(data) ? data : [data]),
	setDeletedTaskData: (state, data) => (state.deletedTaskData = Array.isArray(data) ? data : [data]),
	setRetFile: (state, file) => {
		state.retFile = file;
	},
	setStatusTask: (state, status) => (state.statusTask = status),
	addToMyTasks: (state, task) => {
		let sameTask = state.myTasks.find((myTask) => myTask.pid === task.pid);
		if (!sameTask) state.myTasks.push(task);
		//console.log(state.myTasks);
	},
	updateTaskInMyTasks: (state, { pid, result, status }) => {
		let task = state.myTasks.find((task) => task.pid === pid);
		task.result = result;
		task.status = status;
	},
	removeTaskInMyTasks: (state, pid) => {
		for (let task in state.myTasks) {
			if (state.myTasks[task].pid === pid) {
				state.myTasks.splice(task, 1);
			}
		}
	},
	setFileNames: (state, { files, userFiles }) => {
		state.filesArray = [];
		if (files)
			if (Array.isArray(files))
				for (let file of files) {
					state.filesArray.push(file);
				}
			else state.filesArray.push(files);
		if (userFiles)
			if (Array.isArray(userFiles))
				for (let file of userFiles) {
					state.filesArray.push(file);
				}
			else state.filesArray.push(userFiles);
	}
};

const actions = {
	getLink({ commit, rootState }, sectionId) {
		//get sections tasks by users roles
		return new Promise((resolve, reject) => {
			luaScript("userTasks", "getLinkedTasks", {app: sectionId}, rootState.login)
			// getQuery('getLink_all', [sectionId], rootState.login)
				.then((result) => {
					commit('setRTTasks', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getCmdLine({ commit, rootState }, taskId) {
		return new Promise((resolve, reject) => {
			getQuery('getCmdLine', [taskId], rootState.login)
				.then((result) => {
					commit('setCmdLine', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getQueueTasks({ commit, rootState }, taskStatus) {
		let commitFn;
		if (taskStatus === 1) commitFn = 'setRunningTaskData';
		else if (taskStatus === 2) commitFn = 'setFinishedTaskData';
		else if (taskStatus === 3) {
			commitFn = 'setDeletedTaskData';
		} else {
			commit('setError', 'Wrong taskStatus');
			return;
		}
		let queueFunction;
		if(+rootState.login.user.roleid <= 1) queueFunction = getQuery('getQueueTasks', [taskStatus], rootState.login);
		else queueFunction = getQuery('getQueueTasksByRole', [taskStatus, rootState.login.user.roleid], rootState.login);
		return new Promise((resolve, reject) => {
			queueFunction
				.then((result) => {
					commit(commitFn, result);
					resolve(result);
				})
				.catch(() => {
					reject();
				});
		});
	},
	execRunTask({ rootState, commit, dispatch }, { formData, caption }) {
		let queue;
		let upgResult;
		return new Promise((resolve, reject) => {
			postToServer(formData, rootState.login)
				.then((result) => {
					//узнаю, какой номер текущей задачи в списке
					//узнаю pid и текущие статус и результаты
					if (typeof result !== 'object') {
						// пришел номер задачи
						queue = result;
					} else {
						// если был запушен апгрейд
						if (result.busy.length > 0) {
							reject({ clean: result.clean, busy: result.busy });
							return;
						} else if (result.run && typeof result.run[0] === 'string') {
							this.state.login.error = result.run[0];
							reject(result.run[0]);
							return;
						} else {
							queue = result.run[0];
							upgResult = result.clean;
						}
					}
					return dispatch('getStatusTask', queue);
				})
				.then((taskStatus) => {
					//console.log('getStatusTask in execRunTask');
					//console.log('queueId in dispatch', queue);
					let task = new Task(queue, caption, taskStatus.pid, taskStatus.result, taskStatus.statusTask);
					commit('addToMyTasks', task);
					return dispatch('updateStatusTask', { queueId: queue });
				})
				.then(() => {
					resolve({ queue, clean: upgResult });
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getStatusTask({ rootState }, queueId) {
		return new Promise((resolve, reject) => {
			getQuery('getStatusTask', [queueId], rootState.login)
				.then((result) => {
					//console.log(result);
					resolve(result);
				})
				.catch(() => {
					reject();
				});
		});
	},
	updateStatusTask({ dispatch, commit }, { queueId }) {
		let count = 0;

		return new Promise((resolve, reject) => {
			setTimeout(function run() {
				// //console.log('in getStatusTask');
				dispatch('getStatusTask', queueId)
					.then((result) => {
						//console.log('result: ', result);
						commit('updateTaskInMyTasks', {
							pid: result.pid,
							result: result.result,
							status: result.statusTask
						});
						count++;
						//console.log(result);
						// console.log(count);
						if (result.statusTask === '2' || result.statusTask === '3') {
							// clearTimeout(timerId);
							resolve();
						} else if (count >= 1000) {
							commit('updateTaskInMyTasks', {
								pid: result.pid,
								result: 'Timeout',
								status: '4'
							});
							reject();
						} else setTimeout(run, 4000);
					})
					.catch(() => {
						reject();
					});
			});
		});
	},
	getResultLog(context, { type, queueId, fileName }) {
		let objectParams = {
			script: 'runTask',
			funcname: 'get_file_task',
			funcparam: {
				filename: fileName,
				queue: `${queueId}`
			}
		};
		//console.log('Tasks: ', context.state.myTasks);
		return new Promise((resolve, reject) => {
			getFromServer(objectParams, type, context.rootState.login)
				.then((response) => {
					let data;
					if (type === 'blob')
						data = new File([response.data], fileName, {
							type: 'application/octet-stream'
						});
					else if (!response.data.error && type === 'text') data = response.data;
					else data = response.data.error.msg;
					//console.log(data);
					context.commit('setRetFile', data);
					resolve();
				})
				.catch((error) => {
					commit('setError', error);
					reject(error);
				});
		});
	},
	getHelp({ rootState }, idTask) {
		return new Promise((resolve, reject) => {
			getQuery('getTaskHelp', [idTask], rootState.login)
				.then((result) => {
					resolve(result.help);
				})
				.catch(() => {
					reject();
				});
		});
	},
	getQueueTaskById({ commit, rootState }, queueId) {
		return new Promise((resolve, reject) => {
			getQuery('getQueueTasksByQid', [queueId], rootState.login)
				.then((result) => {
					if (result.qFiles !== null || result.qUserFiles !== null) {
						let files = null;
						let userFiles = null;
						if (result.qFiles)
							files = result.qFiles.includes(',') ? result.qFiles.split(',') : result.qFiles;
						if (result.qUserFiles)
							userFiles = result.qUserFiles.includes(',')
								? result.qUserFiles.split(',')
								: result.qUserFiles;
						commit('setFileNames', { files, userFiles });
					}
					resolve(result);
				})
				.catch(() => {
					reject();
				});
		});
	},
	setTaskStatus({ rootState, dispatch }, { newStatus, prevStatus, queueId }) {
		return new Promise((resolve, reject) => {
			execQuery('setTaskStatus', [queueId, prevStatus, newStatus], rootState.login)
				.then(() => {
					return dispatch('getQueueTasks', prevStatus);
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	setTaskStatusMultiple({ rootState, dispatch }, { queueIdArray, newStatus, prevStatus }) {
		return new Promise((resolve, reject) => {
			luaScript('updQueue', 'updQueue', { id: queueIdArray, statusTask: newStatus }, rootState.login)
				.then(() => {
					return dispatch('getQueueTasks', prevStatus);
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	clearZombies({ rootState, dispatch }, withHttpOption) {
		return new Promise((resolve, reject) => {
			let result = '';
			luaScript('zombieCleaner', 'cleaner', { clear_http_errors: withHttpOption }, rootState.login)
				.then((res) => {
					result = res;
					return dispatch('getQueueTasks', 1);
				})
				.then(() => resolve(result))
				.catch((err) => reject(err));
		});
	},
	cleanupTrash({ rootState, dispatch }, { mode, idArray }) {
		return new Promise((resolve, reject) => {
			if (mode === "all") {
				luaScript('cleanupTrash', 'run', { delete: "all" }, rootState.login)
					.then(() => {
						return dispatch('getQueueTasks', 3);
					})
					.then(() => {
						resolve();
					})
					.catch(() => {
						reject();
					});
			}
			else if (mode === "selected" && idArray.length > 0) {
				luaScript('cleanupTrash', 'run', { delete: idArray }, rootState.login)
					.then(() => {
						return dispatch('getQueueTasks', 3);
					})
					.then(() => {
						resolve();
					})
					.catch(() => {
						reject();
					});
			}
			else { console.error("No action selected!"); reject(); }
		});
	},
	delTasksByDays({ rootState, dispatch }, { countday, statusTask }) {
		return new Promise((resolve, reject) => {
			luaScript('updQueue', 'delTasksByDays', { countday, statusTask }, rootState.login)
				.then(() => {
					return dispatch('getQueueTasks', statusTask);
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	uploadAupgFile({ rootState }, file) {
		const formData = new FormData();
		const command = {
			cmd: 'luaFunc',
			params: {
				script: 'upgrades',
				funcname: 'run_upg'
			}
		};
		formData.append('command', JSON.stringify(command));
		formData.append('upload', file);
		return new Promise((resolve, reject) => {
			postToServer(formData, rootState.login)
				.then((result) => {
					console.log('RESULT AUPG: ');
					console.log(result);
					let msg = 'ok';
					if (result.msg) msg = result.msg;
					resolve(msg);
				})
				.catch((error) => {
					console.log('ERROR AUPG: ', error);
					reject(error);
				});
		});
	}
};

const getters = {
	getRTTasks: (state) => state.rttasks,
	getRTTasksByType: (state) => {
		const adminType = "1";
		const appliedTaskType = "2";
		const updateType = "99";
		const adminArray = [];
		const appliedTaskArray = [];
		const updateArray = [];
		if (state.rttasks)
			state.rttasks.forEach((task) => {
				if (task.idTypeTask === adminType) adminArray.push(task);
				else if (task.idTypeTask === appliedTaskType) appliedTaskArray.push(task);
				else if (task.idTypeTask === updateType) updateArray.push(task);
			});
		return {
			adminArray,
			appliedTaskArray,
			updateArray
		};
	},
	getRTCmdLine: (state) => state.cmdLine,
	getRunningTaskData: (state) => state.runningTaskData,
	getFinishedTaskData: (state) => state.finishedTaskData,
	getDeletedTaskData: (state) => state.deletedTaskData,
	getRTRetFile: (state) => state.retFile,
	getMyTasksForTabs: (state) => {
		let array = [...state.myTasks];
		for (let task of array) {
			//console.log(task);
			if (task.result === null) {
				task.class = 'el-icon-loading';
				task.icon = 'info';
			} else if (task.result === 'OK') {
				task.class = '';
				task.icon = 'success';
			} else if (task.result === 'Timeout') {
				task.class = 'el-icon-time';
				task.icon = 'warning';
			} else {
				task.class = '';
				task.icon = 'danger';
			}
		}
		return array;
	},
	getFilesNames: (state) => state.filesArray
};

export default {
	state,
	mutations,
	actions,
	getters
};
